import { calendarEventsLockedStoreReader } from '../store/lockedCalendarStore';
import getStore from '../store/store';
import type { CalendarEvent } from 'owa-calendar-types';
import type { ClientItemId } from 'owa-client-ids';
import type { ViewType } from 'owa-calendar-actions';

export function isEventInitialized(): boolean {
    return !!getInitializedEventId();
}

export function getInitializedEventId(): ClientItemId {
    return getStore().initializedEventId;
}

export function getInitializedEvent(): CalendarEvent | null {
    const initializedEventId = getInitializedEventId();
    if (!initializedEventId) {
        return null;
    }
    return calendarEventsLockedStoreReader.getFullCalendarEvent(null, initializedEventId.Id);
}

export function isContextMenuOpen(): boolean {
    const { viewState } = getStore();
    return getInitializedEvent() && !!viewState && !!viewState.clickEvent;
}

export function getSourceId(): ViewType {
    return getStore().sourceId;
}
